import { FaShieldAlt, FaLeaf, FaHistory} from 'react-icons/fa';

const whyChooseUs = {
    sub: "Nasza Wizja",
    heading: "Przywracamy blask perle ziemi kutnowskiej",
    description: "Realizujemy ambitny projekt rewitalizacji 12-hektarowego parku i zabytkowego dworu, tworząc unikatowy na skalę kraju ogród botaniczny i największe rosarium w Polsce.",
    points: [
        {
            id: 1,
            icon: <FaLeaf />,
            title: 'Największy Ogród Różany',
            content: 'Tworzymy przestrzeń, która stanie się ogrodniczą wizytówką regionu, z tysiącami odmian róż i unikatową roślinnością.',
        },
        {
            id: 2,
            icon: <FaHistory />,
            title: 'Ochrona Dziedzictwa',
            content: 'Z pasją ratujemy XIX-wieczny dwór i przywracamy historyczny układ przestrzenny dawnego majątku.',
        },
        {
            id: 3,
            icon: <FaShieldAlt />,
            title: 'Transparentność i Pasja',
            content: 'Działamy jako Fundacja, angażując ekspertów i lokalną społeczność w proces tworzenia nowoczesnego miejsca kultury.',
        },
    ],
}

export default whyChooseUs;